import { combineReducers } from "redux";
import loadingReducer from "./loadingReducer";
import creatorsReducer from "./creatorsReducer";
import authReducer from "./authReducer";
import { LOGOUT } from "../types";
import sidebarReducer from "./sidebarReducer";
import modalReducer from "./modalReducer";
import nftsReducer from "./nftReducer";
import walletsReducer from "./walletReducer";
import nftTypesReducer from "./nftTypesReducer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    creators: creatorsReducer,
    sidebar: sidebarReducer,
    modal: modalReducer,
    nfts: nftsReducer,
    wallets: walletsReducer,
    nftTypes: nftTypesReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
